import { render, staticRenderFns } from "./AfterJudgementWaiterListTab.vue?vue&type=template&id=08aae6d6&scoped=true&lang=pug"
import script from "./AfterJudgementWaiterListTab.vue?vue&type=script&lang=ts"
export * from "./AfterJudgementWaiterListTab.vue?vue&type=script&lang=ts"
import style0 from "./AfterJudgementWaiterListTab.vue?vue&type=style&index=0&id=08aae6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aae6d6",
  null
  
)

export default component.exports